import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import Z from "../core/parts/zIndex";
import {ShowerTubCombo} from "../core/parts/showerTubCombo";
import {Vanity} from "../core/parts/vanity";
import {Shower} from "../core/parts/shower";
import {Wall} from "../core/parts/wall";
import {BathTubType, VanityTypes, ShowerTypes, ShowerComboTubType} from "../core/constants";
import {getMetadataByDimensions, reorder} from "../../../misc/utils";
import Analytics from "../../../analytics";

import {getCurrentLayout} from "../../appLayout";
import {ShowerAccessories} from "../core/parts/showerAccessories";

class ContextMenu extends Component {

  static propTypes = {
    designNavigationItems: PropTypes.array,
    contextMenuOpen: PropTypes.string,
    hoveredLayer: PropTypes.object,
    handleContextMenuClick: PropTypes.func,
    contextMenuPosition: PropTypes.object,
    contextMenuPonyWall: PropTypes.bool,
    renderGreenLayerByZindex: PropTypes.func,
    closeContextMenu: PropTypes.func,
  };

  state = {
    contextMenuButtons: []
  };

  componentDidMount() {
    this.setContextMenuButtons();
    if (this.props.closeContextMenu) {
      document.addEventListener('click', this.contextMenuBlur)
    }
  }

  contextMenuBlur = (e) => {
    if (!e.target.closest('.contextmenu-buttons')
      && !e.target.closest('.contextmenu-buttons__button')
      && !e.target.closest('.sprocket-container') && !e.target.closest('.canvas')) {
      this.props.closeContextMenu();
    }
  };

  componentWillUnmount() {
    if (this.props.closeContextMenu) {
      document.removeEventListener('click', this.contextMenuBlur)
    }
  }

  setShowerBodySelectionButtons = () => {
    const layout = getCurrentLayout();
    const shower = layout.parts[Shower.id];
    const vanity = layout.parts[Vanity.id];
    const counterTopSize = vanity.counterTopSize();
    const showerTubCombo = layout.parts[ShowerTubCombo.id];

    const showerSubParts = shower.subParts();
    const showerBody = showerSubParts.find((menuItem) => {
      return menuItem.part.partId === "shower_body"
    });
    const currentShowerSize = shower.showerSize();
    let contextMenuButtons = [];

    if (showerTubCombo.showerTubComboIsActive) {
      const showerTubComboSubParts = showerTubCombo.subParts();
      const wallConfiguration = showerTubComboSubParts.find((menuItem) => {
        return menuItem.part.partId === "wall_configuration"
      });
      showerTubCombo.wallConfiguration.features.forEach((wallConfigurationFeature) => {
        contextMenuButtons.push(Object.assign({}, wallConfiguration, {
          subMenuParent: "Walls",
          subMenuText: wallConfigurationFeature.partName,
          intlTranslate: this.props.intl.formatMessage({id: showerTubCombo.wallConfiguration.translateId}),
          bgImageText: wallConfigurationFeature.partName,
          clickFeature: true,
          text: wallConfigurationFeature.partName.includes("Pony") ? "Pony Wall" : "Left Shower Wall"
        }))
      })
    } else if (showerBody && showerBody.part.features.length) {
      showerBody.part.features.forEach((showerBodyFeature) => {
        if (showerBodyFeature.partName.includes(currentShowerSize)) {
          // console.log('showerBodyFeature.partName', showerBodyFeature.partName);
          if (!(counterTopSize === "72in" && layout.type === 1 && showerBodyFeature.partName.includes("15X4"))) {
            const isPony = showerBodyFeature.partName.includes("Pony");
            contextMenuButtons.push(Object.assign({}, showerBody, {
              subMenuParent: "Walls",
              subMenuText: showerBodyFeature.partName,
              intlTranslate: this.props.intl.formatMessage({id: isPony
                  ? "visualizer.bathroom.walls.pony_wall"
                  : "visualizer.bathroom.walls.left_shower_wall"
              }),
              bgImageText: showerBodyFeature.partName,
              clickFeature: true,
              text: isPony ? "Pony Wall" : "Left Shower Wall"
            }))
          }
        }
      })
    }

    const clickedItemIndex = contextMenuButtons.findIndex(item => {
      return showerTubCombo.showerTubComboIsActive
        ? item.subMenuText === showerTubCombo.wallConfiguration.activeFeature.partName
        : item.subMenuText === showerBody.part.activeFeature.partName
    });

    if (clickedItemIndex > 0) {
      contextMenuButtons = reorder(contextMenuButtons, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons
    })
  };

  setWallBButtons = () => {
    const layout = getCurrentLayout();
    let contextMenuButtons = [];

    const wallParent = layout.parts[Wall.id];
    const wallParts = wallParent.subParts().filter((menuItem) => {
      return (menuItem.part.partId === "wall_b") || (menuItem.part.partId === "accent_wall")
    });
    wallParts.forEach((wallPart) => {
      contextMenuButtons.push(Object.assign({}, wallPart, {
        subMenuParent: "Walls",
        subMenuText: wallPart.part.partName,
        bgImageText: wallPart.part.partName,
        text: wallPart.text,
        intlTranslate: this.props.intl.formatMessage({id: wallPart.part.translateId})
      }));
    });

    const vanity = layout.parts[Vanity.id];
    const vanityBacksplash = vanity.subParts().find((menuItem) => {
      return menuItem.part.partId === "vanity_backsplash"
    });
    if (vanityBacksplash) {
      contextMenuButtons.push(Object.assign({}, vanityBacksplash, {
        subMenuParent: "Vanity",
        subMenuText: vanityBacksplash.part.partName,
        bgImageText: vanityBacksplash.part.partName,
        text: vanityBacksplash.text,
        intlTranslate: this.props.intl.formatMessage({id: vanityBacksplash.part.translateId})
      }));
    }

    let zIndexToFind = this.props.hoveredLayer.zIndex;

    const clickedItem = contextMenuButtons.find(item => {
      return item.part.activeFeature && item.part.activeFeature.layer && item.part.activeFeature.layer.zIndex === zIndexToFind;
    });
    if (clickedItem && clickedItem.part && clickedItem.part.partId === "vanity_backsplash") {
      const vanityFaucet = vanity.subParts().find((menuItem) => {
        return menuItem.part.partId === "vanity_faucet"
      });
      if (vanityFaucet) {
        contextMenuButtons.push(Object.assign({}, vanityFaucet, {
          subMenuParent: "Vanity",
          subMenuText: vanityFaucet.part.partName,
          bgImageText: vanityFaucet.part.partName,
          text: vanityFaucet.text,
          intlTranslate: this.props.intl.formatMessage({id: vanityFaucet.part.translateId})
        }));
      }
    }

    const clickedItemIndex = contextMenuButtons.findIndex(item => {
      return item.part.activeFeature && item.part.activeFeature.layer && item.part.activeFeature.layer.zIndex === zIndexToFind;
    });

    if (clickedItemIndex > 0) {
      contextMenuButtons = reorder(contextMenuButtons, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons
    })
  };

  setContextMenuButtons() {

    const layout = getCurrentLayout();

    if (this.props.contextMenuOpen === "Shower Body Selection") {
      this.setShowerBodySelectionButtons();
      return
    } else if (this.props.contextMenuOpen === "wall_b_custom") {
      this.setWallBButtons();
      return
    }

    const hoveredParent = this.props.designNavigationItems.find(navItem => {
      return navItem.text === this.props.contextMenuOpen
    });

    let relatedItems = hoveredParent.part.relatedItems;
    if (this.props.contextMenuOpen === "Shower Tub Combo") {
      relatedItems = [...hoveredParent.part.relatedItems, ...hoveredParent.part.getShowerRelatedItems()]
    }

    const clickedItem = this.props.hoveredLayer.zIndex === Z.layouts[layout.getCurrentLayoutName()].Shower.Steam60in.Body["2"]
      ? relatedItems[0]
      : relatedItems.find((item) => {
        let zIndexToFind = this.props.hoveredLayer.zIndex;
        if (this.props.hoveredLayer.zIndex === Z.layouts[layout.getCurrentLayoutName()].Shower.Custom60in.Wall2) {
          zIndexToFind = Z.layouts[layout.getCurrentLayoutName()].Shower.Custom60in.Wall
        }
        if (
          this.props.hoveredLayer.zIndex === Z.layouts[layout.getCurrentLayoutName()].Shower.Custom60in.WallAccent2
        ) {
          zIndexToFind = Z.layouts[layout.getCurrentLayoutName()].Shower.Custom60in.WallAccent
        }
        return item.activeFeature && item.activeFeature.layer.zIndex === zIndexToFind
      });

    let itemsToRender = this.getItemsToRender(hoveredParent);

    // console.log('clickedItem', clickedItem);
    // console.log('relatedItems', relatedItems);
    // console.log('itemsToRender', itemsToRender);

    const clickedItemIndex = itemsToRender.findIndex(item => item.text === clickedItem.partName);
    if (clickedItemIndex > 0) {
      itemsToRender = reorder(itemsToRender, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons: itemsToRender
    })
  }

  getItemsToRender = (hoveredParent) => {
    const layout = getCurrentLayout();
    let itemsToRender = hoveredParent.part.subParts();

    if ((this.props.contextMenuOpen === "Shower" || this.props.contextMenuOpen === "Shower Tub Combo") && hoveredParent.text !== "Shower Accessories") {
      itemsToRender = itemsToRender.filter(menuButton => {
        return this.props.contextMenuPonyWall
          ? menuButton.part.isPonyWallPart && menuButton.part.partId !== "pony_wall"
          : !menuButton.part.isPonyWallPart
      });
      const accessoriesParent = layout.parts[ShowerAccessories.id];
      if (accessoriesParent && accessoriesParent.categoryEnabled && !this.props.contextMenuPonyWall) {
        itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "shower_interior_wall_accent");
        itemsToRender.push({
          text: "Accessories",
          part: {},
          subNav: true,
          intlTranslate: this.props.intl.formatMessage({id: "visualizer.bathroom.accessories"})
        })
      }
      itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "shower_head");
      if (layout.parts[ShowerTubCombo.id] && !this.props.contextMenuPonyWall) {
        itemsToRender.push({
          text: "Configure Layout",
          part: {},
          subNav: true,
          intlTranslate: this.props.intl.formatMessage({id: "visualizer.bathroom.contextmenu.configureLayout"})
        })
      }
    }

    if (this.props.contextMenuOpen === "Shower") {
      itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "threshold");
    }
    if (this.props.contextMenuOpen === "Shower Tub Combo") {
      itemsToRender = this.removeNotUsedTubItemsFromContextMenu(itemsToRender, hoveredParent.part.bottomTub);
    }
    if (this.props.contextMenuOpen === "Vanity") {
      itemsToRender = itemsToRender.filter((itemToRender) => {
        return itemToRender.part.partId !== "vanity_mirror" && itemToRender.part.partId !== "vanity_backsplash";
      });
    }

    return itemsToRender
  };

  removeNotUsedTubItemsFromContextMenu = (itemsToRender, activeTub) => {
    return itemsToRender.filter((itemToRender) => {
      let keepThisItem = true;
      Object.keys(ShowerComboTubType).forEach((key) => {
        if (itemToRender.part.partId === ShowerComboTubType[key] && itemToRender.part.partId !== activeTub
          && itemToRender.part.partId !== ShowerComboTubType.replacement_tub
          && itemToRender.part.partId !== ShowerComboTubType.bathtub_liner
        ) {
          keepThisItem = false
        }
      });
      if (itemToRender.text === "Wall Configuration") {
        keepThisItem = false
      }
      return keepThisItem
    });
  };

  handleSubNavClick = (menuItem) => {
    const layout = getCurrentLayout();

    if (menuItem.text === "Accessories") {
      const hoveredParent = this.props.designNavigationItems.find(navItem => {
        return navItem.text === "Shower Accessories"
      });
      this.setState({
        contextMenuButtons: this.getItemsToRender(hoveredParent)
          .map(button => {
            button.subMenuParent = "Shower Accessories";
            return button
          })
      });
      return false
    }

    const showerSubParts = layout.parts[Shower.id].subParts();

    const shower = showerSubParts.find((menuItem) => {
      return menuItem.part.partId === "shower_body"
    });
    shower.subMenuText = "Shower";
    shower.subMenuParent = "Shower";
    shower.intlTranslate = this.props.intl.formatMessage({id: "visualizer.bathroom.shower"});

    const showerTubCombo = layout.parts[ShowerTubCombo.id];
    const showerTubComboSubParts = showerTubCombo.subParts();

    const activeTubMenuItems = showerTubComboSubParts.filter(menuItem => menuItem.part.bottomTubId);
    activeTubMenuItems.forEach(menuItem => menuItem.subMenuParent = "Shower Tub Combo");

    const wallConfiguration = showerTubComboSubParts.find((menuItem) => {
      return menuItem.part.partId === "wall_configuration"
    });
    wallConfiguration.subMenuText = "Shower Tub Combo";
    wallConfiguration.subMenuParent = "Shower Tub Combo";
    wallConfiguration.intlTranslate = this.props.intl.formatMessage({id: "visualizer.bathroom.shower_tub_combo"});

    this.setState({
      contextMenuButtons: [
        shower,
        wallConfiguration,
        ...activeTubMenuItems,
      ]
    })
  };

  handleContextMenuHover = (menuItem) => {
    const layout = getCurrentLayout();
    const hoveredButton = menuItem.text === "Countertop" ? "CounterTop" : menuItem.text;
    const hoveredParent = menuItem.subMenuParent || this.props.contextMenuOpen;

    const layoutType = layout.getCurrentLayoutName();

    // console.log('hoveredButton', hoveredButton);
    // console.log('hoveredParent', hoveredParent);

    if (hoveredButton && hoveredParent) {

      let hoveredZindex = "";

      if (hoveredParent === "Shower") {
        const shower = layout.parts.Shower;
        if (shower.activeSubType_ === ShowerTypes.Complete) {
          switch (hoveredButton) {
            case "Fixture":
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Steam60in[hoveredButton];
              break;
            default:
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Steam60in.Body["1"]; // 1st part of shower
              break;
          }
        } else {
          switch (hoveredButton) {
            case "Shower Walls":
              hoveredZindex = Z.layouts[layoutType].Shower.Custom60in.Wall;
              break;
            case "Shower Body":
              if (shower.showerDoor && shower.showerDoor.features.length) {
                hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.ShowerDoor;
              } else {
                hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.Glass;
              }
              break;
            case "Shower Door":
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.ShowerDoor;
              break;
            case "Handle":
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.ShowerDoorHandle;
              break;
            case "Shower Pan":
            case "Shower Pans":
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.ShowerPanCombo;
              break;
            case "Shower Walls Accent":
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in.WallAccent;
              break;
            case "Pony Wall Glass":
              hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.PonyWallGlass;
              break;
            case "Pony Wall Cap":
              hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.PonyWallCap;
              break;
            case "Floor":
              hoveredZindex = shower.showerFloorIsActive
                ? Z.layouts[layoutType][hoveredParent].Custom60in[hoveredButton]
                : Z.layouts[layoutType][hoveredParent].Custom60in.ShowerPanCombo;
              break;
            default:
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Custom60in[hoveredButton];
              break;
          }
        }
      } else if (hoveredParent === "Shower Tub Combo") {
        switch (hoveredButton) {
          case "Shower Door":
            hoveredZindex = Z.layouts[layoutType].Shower.Custom60in.ShowerDoor;
            break;
          case "Shower Walls":
            hoveredZindex = Z.layouts[layoutType].Shower.Custom60in.Wall;
            break;
          case "Shower Walls Accent":
            hoveredZindex = Z.layouts[layoutType].Shower.Custom60in.WallAccent;
            break;
          case "Fixture":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.Fixture;
            break;
          case "Handle":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.ShowerDoorHandle;
            break;
          case "Wall Configuration":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.ShowerDoor;
            break;
          case "Jetted Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.JettedTub;
            break;
          case "Tub Liner":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.Liner;
            break;
          case "Walk In Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.WalkInTub;
            break;
          case "Replacement Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.ReplacementTub;
            break;
          case "Pony Wall Glass":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.PonyWallGlass;
            break;
          case "Pony Wall Cap":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Custom60in.PonyWallCap;
            break;
          default:
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo[hoveredButton.replace(/ /g, "")];
            break;
        }
      } else if (hoveredParent === "Vanity") { // Vanity
        if (layout.parts.Vanity.activeSubType_ === VanityTypes.Complete) {
          switch (hoveredButton) {
            case "Vanity":
              hoveredZindex = Z.layouts[layoutType].Vanity.Complete.Cabinet;
              break;
            case "Accent Wall":
              hoveredZindex = Z.layouts[layoutType].Wall_A_Accent_Mask;
              break;
            default:
              hoveredZindex = Z.layouts[layoutType].Vanity.Custom[hoveredButton]; // Mirror
              break;
          }
        } else {
          switch (hoveredButton) {
            case "Accent Wall":
              hoveredZindex = Z.layouts[layoutType].Wall_A_Accent_Mask;
              break;
            case "Backsplash":
              hoveredZindex = Z.layouts[layoutType].Vanity.Custom.VanityBacksplash;
              break;
            default:
              hoveredZindex = Z.layouts[layoutType].Vanity.Custom[hoveredButton];
              break;
          }
        }
      } else if (hoveredParent === "Bathtub") { // Bathtub
        if (layout.parts.Bathtub.activeSubType_ === BathTubType.FreeStanding) {
          if (hoveredButton === "Bathtub") {
            hoveredZindex = Z.layouts[layoutType].BathTub.FreeStanding.Base
          } else {
            hoveredZindex = Z.layouts[layoutType].BathTub.FreeStanding[hoveredButton]
          }
        } else {
          if (hoveredButton === "Rim") {
            hoveredZindex = Z.layouts[layoutType].BathTub.Custom60in.Top
          } else {
            hoveredZindex = Z.layouts[layoutType].BathTub.Custom60in[hoveredButton]
          }
        }
      } else if (hoveredParent === "Walls") { // Bathtub
        switch (hoveredButton) {
          case "Pony Wall":
            hoveredZindex = Z.layouts[layoutType].Shower.Custom60in.PonyWall;
            break;
          case "Left Shower Wall": {
            const wallParent = layout.parts[hoveredParent];
            const activeShowerGroup = wallParent.getActiveShowerGroup();
            const showerDimensions = getMetadataByDimensions(activeShowerGroup.showerDimensions());
            hoveredZindex = showerDimensions === "Half"
              ? Z.layouts[layoutType].Shower.Custom60in.ExtrusionWallLeftHalfWall
              : Z.layouts[layoutType].Shower.Custom60in.ExtrusionWallLeft;
            break;
          }
          default:
            hoveredZindex = Z.layouts[layoutType].Vanity.Custom[hoveredButton];
            break;
        }
      }

      this.props.renderGreenLayerByZindex(hoveredZindex);
    }

  };

  render() {

    let contextMenuStyles = this.props.contextMenuPosition || {};
    if (this.state.contextMenuButtons.length === 4) {
      contextMenuStyles = Object.assign({}, contextMenuStyles, {maxWidth:"210px"} )
    }

    return (
      <div className="contextmenu" style={contextMenuStyles}>
        <div className="contextmenu-buttons">
          {this.state.contextMenuButtons.map((menuItem) => {
            return menuItem ? (
              <button key={menuItem.subMenuText || menuItem.text}
                      onClick={menuItem.subNav
                        ? () => this.handleSubNavClick(menuItem)
                        : () => {
                        Analytics.sendClickEvent('context-menu-' + menuItem.text);
                        this.props.handleContextMenuClick(menuItem);
                      }}
                      data-parent={this.props.contextMenuOpen}
                      onMouseOver={this.props.renderGreenLayerByZindex ? () => this.handleContextMenuHover(menuItem) : () => {}}
                      className={"contextmenu-buttons__button contextmenu-buttons__button--"
                      +(menuItem.bgImageText || menuItem.text).toLowerCase().replace(/ /g,"-")}>
                {menuItem.text === "Configure Layout" ? (
                  <div className="sprocket-container">
                    <div className="sprocket small spin reverse"/>
                    <div className="sprocket large spin"/>
                  </div>
                ) : null}
                <span className="contextmenu-buttons__button-text">
                  {menuItem.intlTranslate || menuItem.subMenuText ||
                  (menuItem.part && menuItem.part.translateId ? <FormattedMessage id={menuItem.part.translateId}/> : menuItem.text)}
                </span>
              </button>
            ) : null
          })}
        </div>
      </div>
    )
  }
}

export default injectIntl(ContextMenu)
